import AuthenticationContext from 'adal-angular';
import * as R from "ramda";

const KEY_FORCE_CLEAR_CACHE = 'force_clear_cache';

const isEmpty = (value) => {
  return R.isEmpty(value) || R.isNil(value);
};

window.adalInstance = new AuthenticationContext(JSON.parse(ADAL_CONFIG));

const acquireTokenPromise = (adal, clientId) => {
  return new Promise((resolve, reject) => {
    adal.acquireToken(clientId, (err, token) => {
      if (!isEmpty(err)) {
        reject(err);
        window.login();
      } else {
        resolve(token);
      }
    });
  });
};

window.logout = () => {
  markForceClearCache();
  window.adalInstance.logOut();
};

window.fetchToken = async (config) => {
  const resource = window.adalInstance.getResourceForEndpoint(config.url);
  return await acquireTokenPromise(window.adalInstance, resource);
};

function authenticateToken() {
  return !!adalInstance.getCachedUser();
}

if (adalInstance.isCallback(window.location.hash)) {
  adalInstance.handleWindowCallback();
}

if (window === window.parent) {
  if (authenticateToken()) {
    let script = document.createElement('script');
    script.src = "/dist/bundle.js";
    document.body.appendChild(script);
  } else {
    markForceClearCache();
    window.adalInstance.login();
  }
}

window.login = () => {
  markForceClearCache();
  window.adalInstance.login();
};

function markForceClearCache() { sessionStorage.setItem(KEY_FORCE_CLEAR_CACHE, 'true'); }
